import { render, staticRenderFns } from "./FeaturedCard.vue?vue&type=template&id=d6d45804"
import script from "./FeaturedCard.vue?vue&type=script&lang=js"
export * from "./FeaturedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports